import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { BlockedState } from './blockedState';

@Injectable({
  providedIn: 'root'
})
export class BlockingTaskService {

  /**
   * Observer for blocked state
   */
private mOnBlockedChanged = new BehaviorSubject<BlockedState>({blocked:false});


numRequests = 0;
maxDuration = 70000;

/**
 * Blocked observer
 *
 */
 get onBlockedChanged() {return this.mOnBlockedChanged; }

runPromise(task: Promise<any>, message?: any): Promise<any> {
    return new Promise((resolved, reject) => {
      this.showLoading();
        task.then(ok => {
            this.hideLoading();
            resolved(ok);
        },
        error => {
            this.hideLoading();
            reject(error);
        });

  });
}


runObservable(task: Observable<any>, message?: any): Promise<any> {
    return new Promise((resolved, reject) => {
      this.showLoading();
      const subs = task.subscribe({
          next: (ok:any) => {
            subs.unsubscribe();
            this.hideLoading();
            resolved(ok);
            console.log('Observable task terminated');
          },
          error: (error: any) => {
            subs.unsubscribe();
            this.hideLoading();
            reject(error);
          }
        });


  });
}


private showLoading(message?:string) {

  if (this.numRequests > 0) {
    console.log('showLoading - Already showing');
    this.numRequests++;
  } else {
    console.log('showLoading');
    this.numRequests++;
    this.mOnBlockedChanged.next({blocked:true, message});
  }

}

private hideLoading() {
  this.numRequests--;
  if(this.numRequests === 0) {
    console.log('hideLoading - Dismiss');
    this.mOnBlockedChanged.next({blocked:false});

  }else if (this.numRequests < 0) {
      console.error('Invalid numer of requests');
      this.mOnBlockedChanged.next({blocked:false});
  }
}

}
